import React from 'react';
import { connect } from 'react-redux';
// Popup imports
import { UpdatePopupProps, CloseActivePopup } from '../../../../actions/popupActions';
import { PopupTypes } from '../../Enums';
import LevelSettingsModeEnum from './enums';
// Game(kit) imports
import gameKit from '../../../../../GameKit';
// Level editor imports
import { itemSelectorToggle } from '../../../../actions/levelEditorActions';
// Shared imports
import { ViewDirection } from '../../../../../GameKit/shared';
import settings from '../../../../../settings';

class LevelSettingsView extends React.Component {
    handleSetSideView = () => {
        const { levelUuid } = this.props;
        gameKit.updateLevelSettings(levelUuid, { view: ViewDirection.Side });

        this.postChooseView();
    };

    handleSetTopView = () => {
        const { levelUuid } = this.props;
        gameKit.updateLevelSettings(levelUuid, { view: ViewDirection.TopDown });

        this.postChooseView();
    };

    postChooseView = () => {
        const { dispatch, levelEditor, initial } = this.props;

        if (!levelEditor.itemSelectorOpen && initial) {
            dispatch(itemSelectorToggle());
        }

        dispatch(CloseActivePopup());
    };

    handleBack = () => {
        const { dispatch, fromLevelGrid, levelUuid } = this.props;
        dispatch(
            UpdatePopupProps(PopupTypes.LEVEL_SETTINGS, {
                mode: LevelSettingsModeEnum.MAIN,
                fromLevelGrid,
                levelUuid
            })
        );
    };

    getExitButton = (isPadding = false) => {
        const { initial } = this.props;
        if (initial || isPadding) {
            return <div className="padding" />;
        }
        return (
            <div className="btn-back-container">
                <button className="btn-back" type="button" onClick={this.handleBack}>
                    terug
                </button>
            </div>
        );
    };

    render = () => {
        return (
            <div id="level-settings-view">
                {this.getExitButton()}
                <div className="view-option" id="view-option-side" onClick={this.handleSetSideView}>
                    <img className="view-option-preview" src={`${settings.assetsPath}img/side-view-preview.png`} alt="Zij aanzicht" />
                    <div className="view-option-text">
                        <img src={`${settings.assetsPath}img/side-view-controls.png`} alt="Zijaanzicht controls" />
                        <div>
                            <h2>Zijaanzicht</h2>
                            <p>Beweeg je speler heen en weer, spring of val</p>
                            <button type="button" onClick={this.handleSetSideView}>
                                kies
                            </button>
                        </div>
                    </div>
                </div>
                <div className="view-option" id="view-option-top" onClick={this.handleSetTopView}>
                    <img className="view-option-preview" src={`${settings.assetsPath}img/top-view-preview.png`} alt="Boven aanzicht" />
                    <div className="view-option-text">
                        <img src={`${settings.assetsPath}img/top-view-controls.png`} alt="Bovenaanzicht controls" />
                        <div>
                            <h2>Bovenaanzicht</h2>
                            <p>Beweeg je speler alle kanten op</p>
                            <button type="button" onClick={this.handleSetTopView}>
                                kies
                            </button>
                        </div>
                    </div>
                </div>
                {this.getExitButton(true)}
            </div>
        );
    };
}

const mapDispatchToProps = dispatch => ({
    dispatch
});

const mapStateToProps = state => ({
    levelSettings: state.levelSettings,
    levelEditor: state.levelEditor
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(LevelSettingsView);
